import { z } from "zod";

export const envSchema = z.object({
  VITE_CLERK_PUBLISHABLE_KEY: z.string(),
  VITE_PUBLIC_POSTHOG_KEY: z.string().optional(),
});

export const env = envSchema.parse(import.meta.env);
